define('modules/lp_integration/views/zapier_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/zapier_popup'],function(require, exports, module){
  "use strict";
  var ModalView = require("common/views/modal_view");
  module.exports = ModalView.extend({
    template: require("ldsh!../templates/zapier_popup"),
    events: {
      "click .js-save": "save",
      "click .js-cancel": "hide"
    },
    save: function(e){
      e.preventDefault();
      this.hide();
    }
  });
});

